import { marketingPostalCodeRetrieve } from '@sidegigllc/api/client'

const ZIP_MAX_DISTANCE_TO_MARKET = 100

export async function getClosestMarketToZip(zip: string) {
  const data = await marketingPostalCodeRetrieve(zip)
  const marketInfo = data.markets?.[0]
  if (!marketInfo) return
  if (marketInfo.distance > ZIP_MAX_DISTANCE_TO_MARKET) return
  return marketInfo.id
}

export async function getClosestMarketObjectToZip(zip: string) {
  const data = await marketingPostalCodeRetrieve(zip)
  return data.markets?.[0]
}
